import React from 'react';

const BalanceTab = ({
  balance,
  balanceError,
  balanceLoading,
  fetchBalance,
  performanceVisible,
  performanceStats,
  performanceLoading,
  performanceError,
  performanceRange,
  onTogglePerformance,
  onSelectPerformanceRange,
  onApplyCustomRange,
  onChangePerformanceRange
}) => {
  const formatCurrency = (value) => {
    if (value === null || value === undefined) {
      return '미반영';
    }
    return `₩${Number(value || 0).toLocaleString()}`;
  };

  const formatCount = (value) => {
    if (value === null || value === undefined) {
      return '미반영';
    }
    return `${Number(value || 0)}개`;
  };

  const balanceData = balance || {};
  const performance = performanceStats || {};
  const amounts = performance.amounts || {};
  const stockValue = performance.balance?.stock_value ?? balanceData.stock_value ?? 0;
  const totalBuy = Number(amounts.total_buy ?? 0);
  const totalSell = Number(amounts.total_sell ?? 0);
  const expectedTotalPL = stockValue - (totalBuy - totalSell);

  return (
    <div className="balance-tab">
      <div className="balance-header">
        <h2>계좌 잔고</h2>
        <button onClick={fetchBalance} className="btn-refresh">
          🔄 새로고침
        </button>
      </div>

      {balanceLoading && (
        <p style={{ marginTop: '20px', color: '#666' }}>잔고 정보를 불러오는 중...</p>
      )}

      {balanceError && (
        <p style={{ marginTop: '20px', color: '#dc3545' }}>{balanceError}</p>
      )}

      {!balanceLoading && (
        <div className="balance-info">
          {balanceData.message && (
            <p style={{ marginBottom: '12px', color: '#856404', background: '#fff3cd', padding: '8px 12px', borderRadius: 4 }}>{balanceData.message}</p>
          )}
          <div className="balance-item">
            <div className="balance-label">예수금</div>
            <div className="balance-value">{formatCurrency(balanceData.cash)}</div>
          </div>
          <div className="balance-item">
            <div className="balance-label">보유종목평가액</div>
            <div className="balance-value">{formatCurrency(balanceData.stock_value)}</div>
          </div>
          <div className="balance-item">
            <div className="balance-label">현금잔액</div>
            <div className="balance-value">{formatCurrency(balanceData.availableCash)}</div>
          </div>
          <div className="balance-item total">
            <div className="balance-label">총액</div>
            <div className="balance-value">{formatCurrency(balanceData.totalValue)}</div>
          </div>
          <div className="balance-item">
            <div className="balance-label">보유 종목 수</div>
            <div className="balance-value">{formatCount(balanceData.holdings)}</div>
          </div>
        </div>
      )}

      <div className="performance-section">
        <button type="button" className="performance-toggle" onClick={onTogglePerformance}>
          {performanceVisible ? '▼ 거래실적 감추기' : '▶ 거래실적 보기'}
        </button>

        {performanceVisible && (
          <div className="performance-panel">
            <div className="performance-controls">
              <div className="performance-periods">
                <button
                  type="button"
                  className={performanceRange.type === 'week' ? 'active' : ''}
                  onClick={() => onSelectPerformanceRange('week')}
                >
                  주간
                </button>
                <button
                  type="button"
                  className={performanceRange.type === 'month' ? 'active' : ''}
                  onClick={() => onSelectPerformanceRange('month')}
                >
                  월간
                </button>
                <button
                  type="button"
                  className={performanceRange.type === 'quarter' ? 'active' : ''}
                  onClick={() => onSelectPerformanceRange('quarter')}
                >
                  3개월
                </button>
              </div>
              <div className="performance-custom">
                <label>
                  시작일
                  <input
                    type="date"
                    value={performanceRange.startDate}
                    onChange={(e) => onChangePerformanceRange({ ...performanceRange, startDate: e.target.value })}
                  />
                </label>
                <label>
                  종료일
                  <input
                    type="date"
                    value={performanceRange.endDate}
                    onChange={(e) => onChangePerformanceRange({ ...performanceRange, endDate: e.target.value })}
                  />
                </label>
                <button type="button" onClick={onApplyCustomRange}>
                  달력 적용
                </button>
              </div>
            </div>

            {performanceLoading && (
              <p className="performance-status">거래실적을 불러오는 중...</p>
            )}

            {performanceError && (
              <p className="performance-status error">{performanceError}</p>
            )}

            {!performanceLoading && !performanceError && (
              <div className="performance-grid">
                <div className="performance-card">
                  <div className="label">매수</div>
                  <div className="value">{formatCurrency(amounts.total_buy)}</div>
                </div>
                <div className="performance-card">
                  <div className="label">매도</div>
                  <div className="value">{formatCurrency(amounts.total_sell)}</div>
                </div>
                <div className="performance-card">
                  <div className="label">보유종목평가액</div>
                  <div className="value">{formatCurrency(stockValue)}</div>
                </div>
                <div className="performance-card total">
                  <div className="label">예상 총손익 (보유종목평가액 기준)</div>
                  <div className="value">{formatCurrency(expectedTotalPL)}</div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BalanceTab;
